// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_bXn","cls2":"Header-cls2_BvN Header-cls1_bXn"};